export const snowfallJsPluginParams = {
  snowfall: {
    count: 54,
    canvasHeightLimit: 4,
  },
  switches: {
    txt: "Sneeuw",
    txtElemAttributes: [
      { type: "data-attribute", name: "txt_id", value: "[702]" },
    ],
    styles: {
      bgClrOff: "#F9E3AE40",
      bgClrOn: "#003f8c",
      toggleClr: "#2496ed",
      txtClr: "#2496ed",
    },
  },
};
